import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { WikiArticleTemplate } from './variants/WikiArticle'

const wikiVariant = {
  ...productRowVariantForPath('wiki', 2),
  Template: WikiArticleTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('wiki')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [wikiVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [wikiVariant],
    fallback: productRows.submsges.fallback,
  },
})
